import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { cfgCaseProcedure4Procedure, cfgCaseProcedureForm4Procedure } from './creation/procedure-creation.models';
import {UserService} from '../../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class ProcedureService {
  constructor(
    private http: HttpClient
  ) {
  }

  searchForProcedure(keyword: string): Observable<cfgCaseProcedure4Procedure[]> {
    return this.http.post<cfgCaseProcedure4Procedure[]>(`/api/procedure/searchForProcedure`, { keyword }, UserService.authorizationHeaderObject);
  }

  getProcedureFromId(id: string): Observable<cfgCaseProcedure4Procedure> {
    return this.http.get<cfgCaseProcedure4Procedure>(`/api/procedure/getProcedureFromId/${id}`, UserService.authorizationHeaderObject);
  }

  getNewProcedure(): Observable<cfgCaseProcedure4Procedure> {
    return this.http.get<cfgCaseProcedure4Procedure>(`/api/procedure/getNewProcedure`, UserService.authorizationHeaderObject);
  }

  deleteProcedure(procedure: cfgCaseProcedure4Procedure): Observable<cfgCaseProcedure4Procedure> {
    return this.http.post<cfgCaseProcedure4Procedure>(`/api/procedure/deleteProcedure`, procedure, UserService.authorizationHeaderObject);
  }

  saveProcedure(procedure: cfgCaseProcedure4Procedure): Observable<cfgCaseProcedure4Procedure> {
    return this.http.post<cfgCaseProcedure4Procedure>(`/api/procedure/saveProcedure`, procedure, UserService.authorizationHeaderObject);
  }

  saveProcedureForm(form: cfgCaseProcedureForm4Procedure): Observable<cfgCaseProcedureForm4Procedure> {
    return this.http.post<cfgCaseProcedureForm4Procedure>(`/api/procedure/saveProcedureForm`, form, UserService.authorizationHeaderObject);
  }

  deleteProcedureForm(form: cfgCaseProcedureForm4Procedure): Observable<cfgCaseProcedureForm4Procedure> {
    return this.http.post<cfgCaseProcedureForm4Procedure>(`/api/procedure/deleteProcedureForm`, form, UserService.authorizationHeaderObject);
  }


}
